import React, { useState, useEffect } from "react";
import axios from "axios";

function LogoNav() {
  const [hash, setHash] = useState("");

  useEffect(() => {
    const fetchExpireHash = async () => {
      const response = await axios.get("https://api.planiranjeprostora.me/api/latest-hash-link");
      console.log("Traje do:", response);
      setHash(response.data.data?.hash_expires_at);
    };

    fetchExpireHash();
  }, []);

  const formattedDate = hash
    ? new Date(hash).toLocaleDateString("sr-Latn", {
        day: "2-digit",
        month: "long",
        year: "numeric",
      })
    : null;

  return (
    <header className="page-header page-header-border">
      <div className="container-lg px-3 d-flex flex-row justify-content-between align-items-center">
        <div className="d-flex w-full justify-between items-center">
          <div>
            <img className="img-logo-cg" src="/logo-cg-full.svg" alt="logo" />
          </div>
          <div className="flex flex-col gap-2">
            <div className="md:text-3xl font-semibold">MDUP planovi - Interne objave</div>
            <div className="text-right">
              <div rel="noopener noreferrer">{`Link važi do: ${formattedDate}`}</div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}

export default LogoNav;
